// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qSGSY","buttons":"styles_buttons__3ie5y"};